/**
 * Per-category accent colors, shared by every view of a shop: the Discover
 * planets, the 3D mall's wing wayfinding, and the scan panel. Lives in its own
 * module so components can read it without importing PublicShopBrowser (which
 * imports them back).
 */
export const CATEGORY_STYLES: Record<string, { color: string; rgb: string }> = {
  'Grocery':     { color: '#4ade80', rgb: '74,222,128' },
  'Electronics': { color: '#60a5fa', rgb: '96,165,250' },
  'Clothing':    { color: '#f472b6', rgb: '244,114,182' },
  'Restaurant':  { color: '#fb923c', rgb: '251,146,60' },
  'Pharmacy':    { color: '#f87171', rgb: '248,113,113' },
  'Supermarket': { color: '#facc15', rgb: '250,204,21' },
  'Cafe':        { color: '#fbbf24', rgb: '251,191,36' },
  'Bakery':      { color: '#fb7185', rgb: '251,113,133' },
}

export const DEFAULT_CAT_STYLE = { color: '#a78bfa', rgb: '167,139,250' }

export function getCatStyle(category?: string | null) {
  return (category ? CATEGORY_STYLES[category] : undefined) ?? DEFAULT_CAT_STYLE
}
